import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import StyledTooltip from "../UI/StyledTooltip";
import Typography from "@mui/material/Typography";

import LayerGroupArrow from "../UI/LayerGroupArrow";
import ProjectContents from "./ProjectContents";

import classes from "./Project.module.css";
import { getProjectPeople } from "../../utils/projectUtils";
import { dataActions } from "../../store";

// implementation of MUI full-width tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function Project(props) {
  const dispatch = useDispatch();
  const projectId = props.project?.id;
  const projects = useSelector((state) => state.data.projects.data);
  const projectInfo = projects.filter((p) => p.id === projectId)?.[0];
  const [showLayerControl, setShowLayerControl] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  useEffect(() => {
    if (showLayerControl) {
      if (!projectInfo.hasOwnProperty("people")) {
        getProjectPeople(projectInfo.id).then((r) => {
          dispatch(
            dataActions.updateProjectPeople({
              id: projectId,
              people: r.data.people,
            })
          );
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showLayerControl]);

  return (
    <>
      {/* header  */}
      <div className={classes["project-control-header"]}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <LayerGroupArrow
            handleClick={() => setShowLayerControl((prevState) => !prevState)}
            show={showLayerControl}
          />
          <Typography
            sx={{
              fontSize: "0.8rem",
              "&:hover": { cursor: "pointer", textDecoration: "underline" },
            }}
            onClick={() => setShowLayerControl((prevState) => !prevState)}
            className={classes["layer-name"]}
          >
            {projectInfo.name}
          </Typography>
        </Box>
        {/* open project description modal  */}
        <StyledTooltip title="Project description">
          <IconButton
            aria-label="project description"
            onClick={handleOpenModal}
            sx={{ p: "0px 3px" }}
          >
            <InfoIcon color="primary" sx={{ fontSize: "1rem" }} />
          </IconButton>
        </StyledTooltip>
        <Dialog
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <DialogTitle>{projectInfo.name}</DialogTitle>
          <DialogContent sx={{ minWidth: "300px" }}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {projectInfo.description}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              aria-label="close overlay selection"
              autoFocus
              onClick={handleCloseModal}
              color="secondary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      {/* contents  */}
      <ProjectContents
        showLayerControl={showLayerControl}
        projectInfo={projectInfo}
      />
    </>
  );
}

export default Project;
